export default __webpack_public_path__ + "static/media/fileStorage.fe98fa23.png";